import { Link } from "react-router-dom";
import { LogoFull } from "./Logo";

const linkCls = "text-white/70 hover:text-[#2563EB] transition-colors";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="border-t border-white/10 mt-24">
      <div className="max-w-7xl mx-auto px-4 md:px-8 py-12 grid md:grid-cols-4 gap-8">
        <div>
          <div className="mb-3">
            <LogoFull height={36} />
          </div>
          <p className="text-white/50 text-sm leading-relaxed">
            Indonesia's command-center for game items, top-ups & vouchers. Powered by undeadshopp.
          </p>
        </div>

        <div>
          <h4 className="text-xs uppercase font-bold tracking-[0.2em] text-white/60 mb-4">Marketplace</h4>
          <ul className="space-y-2 text-sm">
            <li><Link to="/browse" className={linkCls} data-testid="footer-browse">Browse games</Link></li>
            <li><Link to="/auction" className={linkCls} data-testid="footer-auction">Live auctions</Link></li>
            <li><Link to="/browse" className={linkCls} data-testid="footer-trending">Trending items</Link></li>
            <li><Link to="/wallet" className={linkCls} data-testid="footer-wallet">Top-up wallet</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="text-xs uppercase font-bold tracking-[0.2em] text-white/60 mb-4">Support</h4>
          <ul className="space-y-2 text-sm">
            <li><Link to="/help" className={linkCls} data-testid="footer-help">Help center</Link></li>
            <li><Link to="/refund-policy" className={linkCls} data-testid="footer-refund">Refund policy</Link></li>
            <li><Link to="/contact" className={linkCls} data-testid="footer-contact">Contact us</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="text-xs uppercase font-bold tracking-[0.2em] text-white/60 mb-4">Legal</h4>
          <ul className="space-y-2 text-sm">
            <li><Link to="/terms" className={linkCls} data-testid="footer-terms">Terms of service</Link></li>
            <li><Link to="/privacy" className={linkCls} data-testid="footer-privacy">Privacy policy</Link></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10 py-6">
        <p className="text-center text-xs text-white/40 uppercase tracking-[0.2em]">
          © 2026 Ustore × undeadshopp · All systems operational
        </p>
      </div>
    </footer>
  );
}
